export class FormaControle {
  ativo: boolean;
  formaControle: string;
  id: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/formas-controle/shared/forma-controle.model.ts
 **/